import { lazy } from 'react';

const DashboardContainer = lazy(() => import(/* webpackChunkName:"DashBoard" */'../modules/dashboard'));
const errPage = lazy(() => import(/* webpackChunkName:"ErrPage" */'../common/components/NoResultsMsgBlock'));
const AuContainer = lazy(() => import(/* webpackChunkName:"AvailableUnitsContainer" */'../modules/availableunits/AvailableUnitsContainer'));
const SearchContainer = lazy(() => import(/* webpackChunkName:"SearchContainer" */'../modules/search/index.tsx'));
const PageNotFoundComponent = lazy(() => import(/* webpackChunkName:"ErrPage" */'../modules/pagenotfound'));

// ADDED: Function to get cookie value
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop().split(';').shift();
    return cookieValue;
  }
  return null;
};

// ADDED: Function to check if search feature is enabled via cookie
const isSearchFeatureEnabled = () => {
  try {
    // const cookieValue = getCookie('RS_RCIO_ES_WKS_FLAG');
    // const { RS_WKS_FLAG } = window.weeksWebCloudConfig;
    const cookieValue = 'true';
    // Check for truthy values (case-insensitive)
    if (cookieValue) {
      const normalizedValue = cookieValue.toLowerCase().trim();
      return normalizedValue === 'true';
    }
    
    return false;
  } catch (error) {
    console.error('Error reading RS_RCIO_ES_WKS_FLAG cookie:', error);
    return false; // Default to disabled if error reading cookie
  }
};

// Check the feature flag from cookie
const isSearchEnabled = isSearchFeatureEnabled();

const routes = [
  {
    path: `/`,
    exact: true,
    component: DashboardContainer,
    id: 1,
    title: 'RCI - Reshaping The World of Travel With An All-New Travel Network',
    messageGroupId: ['RCI_React_Favorites_Points'],
    pageName: 'dashboard',
  },
  {
    path: '/:productType/availableunits',
    exact: true,
    component: AuContainer,
    title: 'RCI - Reshaping The World of Travel With An All-New Travel Network',
    id: 3,
    messageGroupId: ['PWE_WOW_AvailableUnit', 'PWE_WOW_Common'],
    pageName: 'available-units',
  },
  // CONDITIONAL: Only include search route if cookie flag is enabled
  ...(isSearchEnabled ? [{
    path: '/:productType/search',
    exact: true,
    component: SearchContainer,
    title: 'Search - RCI',
    id: 4,
    messageGroupId: ['PWE_WOW_Search', 'PWE_WOW_Common', 'RCI_Boosting_Reason'],
    pageName: 'search',
  }] : []),
  {
    path: `/loginerror_new`,
    component: errPage,
    title: 'Authentication Failed : RCI',
    id: 5,
    exact: true,
    messageGroupId: ['PWE_WOW_Common'],
    pageName: 'error'
  },
  {
    component: PageNotFoundComponent,
    id: 6,
    messageGroupId: ['PWE_WOW_Common'],
  },
];

export default routes;
